import { Modal } from 'ant-design-vue'
import { createVNode, defineComponent } from 'vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'

const confirm = (
  { title, content, onOk, onCancel, className } = { title: 'Confirm' }
) => {
  Modal.confirm({
    title,
    width: 384,
    closable: true,
    okText: 'Yes',
    cancelText: 'No',
    content: createVNode('div', { style: 'color:#333;' }, content),
    onOk,
    onCancel,
    class: className,
  })
}
export default {
  install: (app) => {
    app.config.globalProperties['$msg'] = { confirm }
  },
}
